<div class="div__busca__botoes">
  <div class="div__filtragem">
    <button class="botoes__div__filtro" (click)="showOrhideFilterPopUp()">
      <img src="assets/images/simbolos/filtro.svg" />
      {{ !showDisplayPopUp ? 'Filtros' : 'Ocultar'}}
    </button>
    <div class="div__inclui__modal" [ngbCollapse]="!showDisplayPopUp">
      <img src="assets/images/simbolos/modal-filter-icon.svg" alt="" class="imagem__modal__filtros">
      <div class="modal__filtros">
        <form [formGroup]="filtraForm">
            <ng-container *ngFor="let input of selectInputs">
              <label class="label__class">{{ input.label }}</label>
              <select [formControlName]="input.formControlName" class="modal__select">
                <option class="options__cadastro" [ngValue]="''">
                  Selecionar
                </option>
                <option *ngFor="let option of input.options" [value]="input?.valor ? input.valor!(option) : option">{{
                  input?.exibir ? input.exibir!(option) : option }}</option>
              </select>
            </ng-container>

          <ng-container *ngFor="let input of filterInputs">
            <label class="label__class">{{ input.label }}</label>
            <input type="text" class="modal__input" [formControlName]="input.formControlName">
          </ng-container>

          <div *ngIf="showOptions">
            <ng-container *ngFor="let input of filterInputsLista">
              <label class="label__class">{{ input.label }}</label>
              <input type="text" class="modal__input" [formControlName]="input.formControlName">
            </ng-container>
            <ng-content>

            </ng-content>
          </div>

          <div class="div__botao">
            <button class="botao__aplicar" (click)="emitFilterData(); OnClickApplyButton.emit()">Aplicar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>